import "../css/Inicio.css";
import Navbar1 from "../components/Navbar1";
import Navbar2 from "../components/Navbar2";
import Panel_Monitoreo from "../components/Panel_Monitoreo";
import Footer from "../components/Footer";

export default function Monitoreo() {
  return (
    <div className="Visualizadores">
      <Navbar1 />
      <Navbar2 />
      <Panel_Monitoreo />
      <Footer />
    </div>
  );
}
